import { render } from "./ResponseSuccessPage.vue?vue&type=template&id=76330c6a"
import script from "./ResponseSuccessPage.vue?vue&type=script&lang=js"
export * from "./ResponseSuccessPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__